<template>
  <div>
    <div class="calendar-wrapper">
      <calendar-header
          :headerProps="periodInfo"
          @input="setShowDate"
          @period-changed="setDisplayPeriod" />
      <calendar-view v-show="calendarMode != 'list' && calendarMode != 'all'" :show-date="showDate" ref="myCalendarView"
        class="theme-default" 
        :items="UserStore.getters.calendarPeriodMeetings().filter(x => x.learnerId === UserStore.state.ContextUserId)"
        :period-changed-callback="loadCalendar"
        :display-period-uom="displayPeriod"
        @click-item="onItemClicked" >
      </calendar-view>
      <div v-if="calendarMode == 'list' || calendarMode == 'all'">
        <div class="row">
          <div class="card-no-data" v-if="UserStore.getters.calendarPeriodMeetings().filter(x => x.learnerId === UserStore.state.ContextUserId).length === 0">No Scheduled Meetings for this time period</div>
          <meeting-card v-for="item in UserStore.getters.calendarPeriodMeetings().filter(x => x.learnerId === UserStore.state.ContextUserId)" :key="item.meetingDto.meetingId" :meeting="item.meetingDto"></meeting-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { injectStrict } from '@/lib/utils';
import { UserStoreKey } from '@/store/StoreInjectionKeys';
import { computed, defineComponent, ref, watch} from '@vue/composition-api';
import router from '@/router';
import { CalendarView } from 'vue-simple-calendar';
import CalendarHeader from './LearnerActivitiesCalendarHeader.vue';
import MeetingCard from '@/modules/ees/components/MeetingCard.vue';

export default defineComponent({
  name: 'LearnerActivitiesCalender',
  components: {
    CalendarView,
    CalendarHeader,
    MeetingCard
  },
  setup() {
    const UserStore = injectStrict(UserStoreKey);
    const myCalendarView = ref(null)
    const showDate = ref(new Date());

    const displayPeriod = ref("month");
    const calendarMode = ref("normal");

    const periodInfo = computed(() => {
      if (myCalendarView && myCalendarView.value && myCalendarView.value.periodStart) {
        return {
          periodLabel: myCalendarView.value.periodLabel,
          previousPeriod: myCalendarView.value.getIncrementedPeriod(-1),
          nextPeriod: myCalendarView.value.getIncrementedPeriod(1),
          currentPeriod: myCalendarView.value.currentPeriodStart,
          currentPeriodLabel: myCalendarView.value.currentPeriodLabelFinal
        }
      }
      else {
        return {}
      }
    })

    var date = new Date();

    const FirstDay = ref(new Date(date.getFullYear(), date.getMonth(), 1));
    const LastDay = ref(new Date(date.getFullYear(), date.getMonth() + 1, 0));

    function loadCalendar(range) {
      const firstDate = calendarMode.value == 'all' ? null : range.displayFirstDate;
      UserStore.actions.getMeetingsForTimePeriod(firstDate, range.displayLastDate);
    }
    
    watch(() => calendarMode, () => {
      loadCalendar({displayFirstDate: FirstDay.value, displayLastDate: LastDay.value})
    }, { immediate: true })

    watch(() => UserStore.state.ContextUserId, (learnerId, oldLearnerId) => {
      if(learnerId !== oldLearnerId){
        loadCalendar({displayFirstDate: FirstDay.value, displayLastDate: LastDay.value});
      }
    });

    function setShowDate(d) {
      showDate.value = d;
    }
    const setDisplayPeriod = (p) => {
      //showDate.value = new Date()
      if (p != 'list' && p != 'all') {
        displayPeriod.value = p;
        calendarMode.value = 'normal';
      }
      else{
        displayPeriod.value = 'month';
        calendarMode.value = p;
      }
      loadCalendar({displayFirstDate: FirstDay.value, displayLastDate: LastDay.value});
    }
    const onItemClicked = (item) => {
      navContextActivity(item.originalItem);
    }
    function navContextActivity(item) {
      router.push(`${item.url}`)
    }

    return {
      UserStore,
      showDate,
      loadCalendar,
      setShowDate,
      periodInfo,
      displayPeriod,
      setDisplayPeriod,
      myCalendarView,
      calendarMode,
      onItemClicked,
      navContextActivity
    }
  }
})
</script>